// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Tx7F7","btn":"style_btn__gDL0V"};